<template>
  <FrkModal name="userTerms">
    <template #title> Mise à jour des Conditions Générales de Services de FreelanceRepublik </template>
    <template #body>
      <p>
        Le {{ termsFormattedUpdatedDate }}, nous avons mis à jour nos Conditions Générales de Services. L'utilisation de
        ce site implique leur acceptation.
      </p>
      <p>Merci d'en prendre connaissance avant de les accepter.</p>
    </template>
    <template #foot>
      <FrkFlexContainer justify="end">
        <FrkButton
          color="secondary"
          href="https://www.freelancerepublik.com/conditions-generales"
          target="_blank"
        >
          Consulter les CGS depuis la page dédiée
        </FrkButton>
        <FrkButton
          :disabled="isLoading"
          @click="acceptTerms"
          color="primary"
        >
          J'accepte les nouvelles CGS
        </FrkButton>
      </FrkFlexContainer>
    </template>
  </FrkModal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';

import { dateUtils } from '@freelancerepublik/helpers';
import { TERMS_OF_CONTRACT_LATEST_UPDATE } from '@freelancerepublik/models-core/TermsList.core';

import FrkModal from '@/components/FrkModal.vue';
import FrkFlexContainer from '@/components/FrkFlexContainer.vue';
import FrkButton from '@/components/FrkButton.vue';

import { useModal } from '@/composables';
import { useMessagesStore } from '@/store/useMessagesStore';
import { AcceptTermsDocument } from './UserTermsModal.generated';

const isLoading = ref(false);

const { resolveClient } = useApolloClient();
const modal = useModal();
const messagesStore = useMessagesStore();

const termsFormattedUpdatedDate = computed(() => dateUtils.formatDate(TERMS_OF_CONTRACT_LATEST_UPDATE, 'Do MMMM YYYY'));

async function acceptTerms() {
  isLoading.value = true;

  try {
    const apolloClient = resolveClient();
    await apolloClient.mutate({
      mutation: AcceptTermsDocument,
    });

    messagesStore.pushFlashMessage({
      message: 'Acceptation enregistrée !',
    });

    modal.hide();
  } catch (err) {
    messagesStore.pushFlashMessage({
      message: err.message,
      colorClass: 'invalid',
    });
  }

  isLoading.value = false;
}
</script>
